import { Component, OnInit } from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {Subject} from 'rxjs';
import {FlowChartDataService} from '../../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-design-quentionare-dialog',
  templateUrl: './design-quentionare-dialog.component.html',
  styleUrls: ['./design-quentionare-dialog.component.scss']
})
export class DesignQuentionareDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  section: any;
  constructor(public flowChartDataService: FlowChartDataService) { }

  ngOnInit() {
  }



  onOkClicked(): boolean {
    return false;
  }

}
